export const SEARCH_HUB_EVENT_NAME_SEARCH_COLLECTOR = 'search-collector';
export const SEARCH_COLLECTOR_EVENT_TYPE_BASKET = 'basket';
export const SEARCH_COLLECTOR_EVENT_TYPE_SEARCH = 'search';
